import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {NewDocumentService} from './new-document.service';
import {AlertController, ModalController} from '@ionic/angular';
import {DocumentModel} from '../models/document.model';
import {ContractHealthCare} from '../modals/healthcare/contract-health-care/contract-health-care';
import {CollectionsNames} from '../definitions/collections-names';
import {StateManagerService} from './state-manager.service';
import {DocumentFromLiveDetailLineService} from './document-from-live-detail-line.service';
import {ContractAndCollectionComponent} from '../modals/healthcare/contract-and-collection/contract-and-collection.component';
import {DocumentTypes} from '../definitions/document-types';

@Injectable({
    providedIn: 'root'
})
export class ContractCreationFromCollectionHealtcareService {
    /*
    * THIS SERVICE WAS MEANT TO BE USED BY HEALTH CARE ONLY
    * DO NOT USE FOR THE MAIN HIRE MODULE
    */

    constructor(private newDocumentService: NewDocumentService,
                private  alertController: AlertController,
                private modalController: ModalController,
                private stateManager: StateManagerService,
                private collectionsNames: CollectionsNames,
                private documentFromLiveDetailLineService: DocumentFromLiveDetailLineService,
                private documentType: DocumentTypes) {
    }

    handleContractCreation(detailLine: DetaillineDTOModel) {
        const newContract = this.newDocumentService.genNewDocument();
        detailLine.detailLineId = 0;
        newContract.documentType = this.documentType.CONTRACTANDCOLLECTION;
        detailLine.fromDate = newContract.creationDate;
        newContract.detailLines.push(detailLine);
        // TODO: Handle Customer, Ward, Patient, Date In/Out
        newContract.customer = this.stateManager.getCollection(this.collectionsNames.CUSTOMER).find(cust => {
            return cust.id === detailLine.custId;
        });
        newContract.site = this.stateManager.getCollection(this.collectionsNames.SITE).find(site => {
            return site.id === detailLine.site;
        });
        this.handleNewContract(newContract);
    }

    private async handleNewContract(newContract: DocumentModel) {
        const modal = await this.modalController.create({
            component: ContractAndCollectionComponent,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': newContract
            }
        });
        modal.onDidDismiss().then(data => {

        });
        return await modal.present();
    }
}
